module.exports = __webpack_public_path__ + "static/media/illustration.870efff6.svg";